import React from "react";
import { LeadFormSection } from "@modules/elearning/lead/components";
import { LayoutMain } from "@unisearch/theme/layout";
import {
  IeltsPageTopSection,
  IeltsPageHighlightsSection,
} from "@modules/elearning/lead";

const LeadIelts = () => {
  return (
    <LayoutMain
      title="Your Target IELTS Score is within Reach"
      footer_with_evaluation
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/elearning/your-target-IELTS-score`}
    >
      <IeltsPageTopSection />
      <IeltsPageHighlightsSection />
      <LeadFormSection subject={"Your Target IELTS Score is Within Reach!"} />
    </LayoutMain>
  );
};

export default LeadIelts;
